// import { useEffect, useRef, useState } from "react";

// interface VisibleElement {
//   [key: string]: boolean;
// }

// const Press: React.FC = () => {
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const [visible, setVisible] = useState<VisibleElement>({});

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible({ main: true });
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <div className="min-h-screen bg-white">
//       <section
//         ref={sectionRef}
//         className="relative w-full py-12 bg-white border-t border-gray-200"
//       >
//         <div className="max-w-7xl mx-auto px-7">
//           <div
//             className={`mb-8 transition-all duration-700 ${
//               visible.main ? "animate-fade-in-up" : "opacity-0"
//             }`}
//           >
//             <div className="inline-block px-4 py-2 bg-gray-100 border border-gray-300 rounded-full text-sm text-gray-700">
//               PRESS
//             </div>
//           </div>

//           <h2
//             className={`text-gray-900 text-8xl md:text-7xl font-medium leading-tight mb-8 transition-all duration-700 ${
//               visible.main ? "animate-fade-in-up" : "opacity-0"
//             }`}
//           >
//             Volaso in the News
//           </h2>

//           <p
//             className={`text-gray-600 text-lg font-light max-w-3xl transition-all duration-700 ${
//               visible.main ? "animate-fade-in-up" : "opacity-0"
//             }`}
//           >
//             This is the space to introduce visitors to the business or brand.
//             Briefly explain who's behind it, what it does and what makes it
//             unique. Share its core values and what this site has to offer.
//           </p>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Press;

import React, { useState } from "react";

const SustanableGreener: React.FC = () => {
  const [activeSection, setActiveSection] = useState(0);

  const sections = [
    {
      content: "Reducing Dependence on Critical Raw Materials",
      description:
        "Our research and development efforts focus on reducing reliance on constrained and geopolitically sensitive raw materials by exploring alternative chemistries, optimized material usage, and efficient cell architectures. By prioritizing durability, efficiency, and extended lifecycle performance, we aim to lower material intensity per unit of energy delivered, supporting more sustainable and resilient energy storage solutions.",
      image: "/first.png",
      imageAlt: "Our mission in action - portable energy solutions",
    },
    {
      content: "Waste to Nano Material Creation.",
      description:
        "To innovate in the field of energy storage by transforming waste materials into high-performance nano materials, thereby contributing to a circular economy and reducing environmental impact.",
      image: "/second.png",
      imageAlt: "Our values guiding sustainable energy solutions",
    },
    {
      content: "CO₂ Reduction",
      description:
        "Cutting carbon emissions through innovative, clean-energy solutions that replace fossil-fuel-dependent systems with sustainable, high-efficiency alternatives driving a greener future and empowering communities to breathe cleaner air.",
      image: "/third.png",
      imageAlt: "Coming soon",
    },
  ];

  return (
    <div className="min-h-max bg-white text-stone-900 py-16">
      <div className="relative px-6 lg:px-20 overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-72 h-72 bg-sky-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-stone-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-sky-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-500"></div>
        </div>

        <div className="relative z-10 max-w-8xl left-5 mx-auto mb-4">
          <div className="text-start">
            <button className="px-6 py-2 text-4xl font-bold text-black backdrop-blur-sm transition-all hover:bg-white/20 md:px-8 md:py-3">
              Sustainable Practices for a Greener Future
            </button>
          </div>
        </div>
      </div>

      <div className="px-6 lg:px-20 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {sections.map((section, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl p-6 border-2 shadow-sm transition-all duration-300 cursor-pointer`}
                onClick={() => setActiveSection(index)}
              >
                <div className="mb-6 rounded-lg overflow-hidden h-48">
                  <img
                    src={section.image}
                    alt={section.imageAlt}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="text-center">
                  <p className="text-2xl text-stone-800 font-bold mb-4 leading-tight">
                    {section.content}
                  </p>
                  <p className="text-stone-600 leading-relaxed text-sm mb-4">
                    {section.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SustanableGreener;
